import {
  THREE_DS_ALLOWED_ORIGINS,
  THREE_DS_COMPLETE_MESSAGE,
  THREE_DS_FAILURE_MESSAGE,
} from "./three-ds.constants";
import type { ThreeDsResult } from "./three-ds.types";

const ALLOW_LOCAL_API =
  !!import.meta.hot || import.meta.env?.BUN_PUBLIC_ENABLE_DEV_CONFIG === "true";

/** The URL to load in the 3DS iframe, or null when it doesn't point at a MoonPay API host. */
export function threeDsFrameUrl(url: string, allowLocal = ALLOW_LOCAL_API): URL | null {
  let parsed: URL;
  try {
    parsed = new URL(url);
  } catch {
    return null;
  }
  if (parsed.username || parsed.password) {
    return null;
  }
  const isLocal =
    allowLocal &&
    parsed.protocol === "http:" &&
    (parsed.hostname === "localhost" || parsed.hostname === "127.0.0.1");
  if (!isLocal && !THREE_DS_ALLOWED_ORIGINS.includes(parsed.origin)) {
    return null;
  }
  // Makes the API post the result to the parent instead of redirecting to the transaction tracker.
  parsed.searchParams.set("iframe", "true");
  return parsed;
}

export function parseThreeDsResult(data: unknown): ThreeDsResult | null {
  if (!data || typeof data !== "object") {
    return null;
  }
  const { message } = data as { message?: unknown };
  if (message === THREE_DS_COMPLETE_MESSAGE) {
    return "complete";
  }
  if (message === THREE_DS_FAILURE_MESSAGE) {
    return "failure";
  }
  return null;
}
